import { Button, ButtonProps, Tooltip } from "@chakra-ui/react";
import React, { useCallback } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useConfirmationDialog } from "src/hooks/useConfirmationDialog";
import * as AF from "src/types/formTemplate";
import { useEditFormTemplateContext } from "../../context";

type RemoveSectionButtonProps = ButtonProps & {
  section: AF.V3.Section;
};

export const RemoveSectionButton: React.FC<RemoveSectionButtonProps> = ({
  section,
}) => {
  const { dispatch, isPublishedMode, helpers } = useEditFormTemplateContext();
  const { confirm, confirmationDialog } = useConfirmationDialog({
    header: "Remove unpublished section?",
    body: "",
    cancelButton: {
      label: "No, cancel",
    },
    confirmButton: {
      label: "Remove",
      colorScheme: "red",
    },
    translate: true,
  });

  const onRemoveButtonClick = useCallback(async () => {
    if (
      !(await confirm({
        body: `This will remove the section "${section.title}" and any questions you have added within it. This can’t be undone.`,
      }))
    ) {
      return;
    }

    dispatch({ type: "RemoveSection", section });
  }, [dispatch, confirm, section]);

  const button = (
    <>
      <Button
        variant="outline"
        colorScheme="gray"
        leftIcon={<RiDeleteBin6Line />}
        onClick={onRemoveButtonClick}
      >
        Remove section
      </Button>
      {confirmationDialog}
    </>
  );

  if (
    isPublishedMode &&
    "questions" in section &&
    section.questions.find((q) => !helpers.isUnpublishedQuestion(q.id))
  ) {
    return (
      <Tooltip label="Please move all published questions from this section to remove this section">
        <Button
          variant="outline"
          colorScheme="gray"
          leftIcon={<RiDeleteBin6Line />}
          isDisabled
        >
          Remove section
        </Button>
      </Tooltip>
    );
  }

  return button;
};
